import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { SUCCEEDED } from 'redux-request-state/requestStates';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import * as AbsolutePaths from 'automation-ui-canvas/constants/AbsolutePaths';
import { AiAssistants } from 'automation-ui-canvas/constants/AiAssistant';
import { useUpdateFlow } from 'automation-ui-canvas/queries/flowQueries';
import { getCurrentlyStagedFlowByFlowId, getFlowValidation, getFlowValidationObjectRequestStatus } from 'automation-ui-canvas/selectors/flowSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function KeepSuggestedActionsButton({
  aiPrompt,
  flowId
}) {
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const currentlyStagedFlow = useSelector(getCurrentlyStagedFlowByFlowId(flowId));
  const flowValidation = useSelector(getFlowValidation(flowId));
  const flowValidationRequestStatus = useSelector(getFlowValidationObjectRequestStatus);
  const [updateFlowMutation, {
    loading
  }] = useUpdateFlow();
  const handleKeepButtonClick = () => {
    trackEvent(Trackables.INSERT_GENERATED_ASSET, {
      aiPrompt,
      assetType: 'AI Generated Workflow Action',
      flowId
    });
    updateFlowMutation({
      variables: {
        sourceApp: SourceApps.WORKFLOWS_APP,
        flow: currentlyStagedFlow,
        aiAssistants: [AiAssistants.WORKFLOWS_AI_ASSISTANT]
      }
    }).then(() => {
      history.push(generatePath(AbsolutePaths.CANVAS_ROOT_WORKFLOW, {
        flowId
      }));
    }).catch(error => {
      // TODO - @mlegocki: handle errors
      console.error('AIAssistantGenerateFlowHeader error: ', error);
    });
  };
  const isInvalid = !!(currentlyStagedFlow !== null && currentlyStagedFlow !== void 0 && currentlyStagedFlow.isEnabled) && !(flowValidation !== null && flowValidation !== void 0 && flowValidation.isValid);
  const button = /*#__PURE__*/_jsx(UILoadingButton, {
    "data-test-id": "ai-assistant-nav-save-button",
    loading: loading || flowValidationRequestStatus !== SUCCEEDED,
    onClick: handleKeepButtonClick,
    use: "primary",
    disabled: isInvalid,
    failed: true // don't show a check mark when laoding finishes
    ,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.aiAssistantGenerateCanvas.header.keepActionsButton"
    })
  });
  if (isInvalid) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.aiAssistantGenerateCanvas.header.invalidActionsTooltip"
      }),
      children: button
    });
  } else {
    return button;
  }
}